import StringColumn from './StringColumn';
import NumericColumn from './NumericColumn';
import BooleanColumn from './BooleanColumn';
import DateColumn from './DateColumn';
import EnumColumn from './EnumColumn';
import LookupColumn from './LookupColumn';
import AutoCompleteStringColumn from './AutoCompleteStringColumn';

const customColumnTypes = [];

function getRendererType(columnOptions) {
	switch (columnOptions.type) {
		case 'enum':
			return EnumColumn;
		case 'bool':
		case 'boolean':
			return BooleanColumn;
		case 'int':
		case 'float':
			return NumericColumn;
		case 'date':
			return DateColumn;
		case 'lookup':
			return LookupColumn;
		case 'string':
		{
			if (columnOptions.useHint === true) {
				return AutoCompleteStringColumn;
			}
			return StringColumn;
		}
		default: {
			// Custom column type resolution
			for (let i = 0; i < customColumnTypes.length; i++) {
				const c = customColumnTypes[i];
				if (c.selector(columnOptions)) {
					return c.type;
				}
			}
		}
	}
	// if no custom column exists, render value as StringColumn
	return StringColumn;
}

export function createRenderer(tableElement, columnOptions, index) {
	let renderer = columnOptions.renderer;
	if (!renderer) {
        const RendererClass = getRendererType(columnOptions);
        renderer = new RendererClass(tableElement, columnOptions, index);
		columnOptions.renderer = renderer;
		columnOptions.sDefaultContent = renderer.defaultContent;
	}
	return renderer;
}

/**
 * Registers new custom column type.
 * @param selectorCallback {function} Function returning boolean value,
 * indicating whether the type can be used for given column. It gets column options as first parameter.
 * @param customColumnType Class derived from StringColumn or any sub-class.
 */
export function registerRenderer(selectorCallback, customColumnType) {
	if (typeof selectorCallback === 'function' && typeof customColumnType === 'function') {
		customColumnTypes.push({selector: selectorCallback, type: customColumnType});
	}
}

export default {
    StringColumn,
    NumericColumn,
    BooleanColumn,
    DateColumn,
    EnumColumn,
    LookupColumn
}


// WEBPACK FOOTER //
// ./node_modules/linksoft-datatables/src/renderers/index.js